import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import styles from "./Header.module.scss";

import MetaTag from "../../meta";
import { LanguageToggle } from "../../common";
import { navItems } from "../../../routes/Navigation";
import { useInfo } from "../../../context/InfoContext";

const Header = () => {
  const {
    i18n: { language, changeLanguage },
    t,
  } = useTranslation();
  const { data: userInfo } = useInfo();
  const location = useLocation();

  const [isScrolled, setIsScrolled] = useState(false);
  const [pathname, setPathname] = useState("/");

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
  };

  useEffect(() => {
    if (location.pathname !== pathname) {
      setPathname(location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}>
      <MetaTag isPathStatic={pathname} />
      <div className={styles.container}>
        <Box className={styles.headerContent}>
          {/* TODO: Add Logo */}
          <Link to="/" className={styles.logo}>
            <img
              src={userInfo?.logoUrl || "https://res.cloudinary.com/daojypjrh/image/upload/logo.jpg"}
              alt={userInfo?.title || "JainGlory Foundation"}
              className={styles.logoImage}
              loading="lazy"
            />
            <span className={styles.labelLogo}>
              {userInfo?.title || "JainGlory Foundation"}
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className={styles.desktopNav}>
            {navItems(t)?.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${styles.navLink} ${
                  (location.pathname?.includes(item.path) &&
                    item.path !== "/") ||
                  location.pathname === item.path
                    ? styles.active
                    : ""
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <LanguageToggle
            lang={language}
            onLanguageChange={handleLanguageChange}
          />
        </Box>
      </div>
    </header>
  );
};

export default Header;
